<app-header-dashboard />
<div class="flex h-[calc(100%-72px)] w-full flex-col overflow-y-auto">
  <app-dashboard />
</div>
